import "./polyfills"; // * It should be first import
import "./init-logrocket";
import React from "react";
import ReactDOM from "react-dom";
import interceptFetch from "./interceptors/fetchInterceptor";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

// * Intercept all fetch calls
interceptFetch();

ReactDOM.render(<App />, document.getElementById("root"));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
